module.exports = __webpack_public_path__ + "img/group-chat.f819e27f.svg";